import { KeybeIconType } from '@/shared/infrastructure/enums/icons/KeybeIconType'
import { mapState } from 'vuex'
import { EventBus } from '@/eventBus'
import KeybeIcon from '@/shared/infrastructure/ui/icons/KeybeIcon.vue'
import KBButton from '@/shared/infrastructure/ui/buttons/KBButton.vue'
import ReferralPayment from '../ReferralPayment/ReferralPayment.vue'
import { BASE_EMAIL_TODO } from '@/modules/consumptions/infrastructure/ui/components/BillingCommissions/constants'
import moment from 'moment'
import FeesServices from '@/modules/configuration/application/services/FeesServices'
import PartnersUseCases from '@/modules/Partners/application/PartnersUseCases'
import PartnersController from '@/modules/Partners/infrastructure/controller/Partners.controller'

export default {
  components: {
    KeybeIcon,
    KBButton,
    ReferralPayment

  },
  data () {
    return {
      KeybeIconType,
      urlSingUp: 'https://v6.keybe.app/signup',
      utm_source: 'Referral-partner',
      utm_medium: '',
      utm_campaign: 'referral-ui',
      utm_term: '',
      utm_content: '',
      urlFormart: '',
      utm_partner: '',
      onReferralPayment: false,
      dates: {},
      totalMonth: null,
      available: null,
      urlSignUpBiky: 'https://biky.app/signup',
      urlFormatAutopilot: '',
      referralsLink: `${process.env.VUE_APP_KEYBE_CO_URL}programa-de-referidos/`,
      partnersLink: `${process.env.VUE_APP_KEYBE_CO_URL}programa-de-partners/`,
      bikyCommissions: `${process.env.VUE_APP_STORAGE_URL}/files/ai/biky_commissions.png`,
      partnerController: new PartnersController()
    }
  },
  computed: {
    ...mapState('UserStore', ['user']),
    ...mapState('AppStore', ['selectedApp']),
    userEmail (): string {
      return this.user?.email || ''
    }
  },
  async mounted () {
    await this.createUrl()
  },
  created () {
    this.getCommissionData()
  },
  methods: {
    getCustomDates () {
      const date = new Date()
      const dateFrom = moment(date).subtract(1, 'month').format('YYYY-MM-25')
      const dateTo = moment(date).format('YYYY-MM-24')
      return { dateFrom, dateTo }
    },
    async getCommissionData () {
      const email = this?.userSelected?.email || this.userEmail
      this.isAll = email === BASE_EMAIL_TODO
      try {
        let dateFrom = ''
        let dateTo = ''
        const date = this.getCustomDates()
        if (!this.dates?.dateFrom || !this.dates?.dateTo) {
          dateFrom = date.dateFrom
          dateTo = date.dateTo
        } else {
          dateFrom = this.dates.dateFrom
          dateTo = this.dates.dateTo
        }
        const data = {
          dateFrom,
          dateTo,
          email: email || this.userEmail
        }
        const feesData = await FeesServices.getCommission(data)
        if (feesData) {
          this.totalMonth = feesData?.data?.current || 0
          this.available = feesData?.data?.user?.balanceUSD
        }
      } catch (error) {
      }
    },
    goback () {
      if (this.onReferralPayment) {
        this.onReferralPayment = false
      }
    },
    async createUrl (): Promise<void> {
      this.urlSingUp = await PartnersUseCases.getPartnerUrl(this.partnerController, 'keybe')
      this.urlSignUpBiky = await PartnersUseCases.getPartnerUrl(this.partnerController, 'biky')
      this.urlFormart = await this.getShortURL(this.urlSingUp)
      this.urlFormatAutopilot = await this.getShortURL(this.urlSignUpBiky)
    },
    copyToClipboard (url: string): void {
      navigator.clipboard.writeText(url).then(() => {
        EventBus.$emit('toast', 'success', this.$t('UrlCopied'))
      }).catch(() => {
        EventBus.$emit('toast', 'error', this.$t('errorCopying'))
      })
    },
    async getShortURL (urlSingUp: string): Promise<Object> {
      const response = await fetch('https://s.kbe.ai/create', {
        method: 'POST',
        body: JSON.stringify({
          url: urlSingUp,
          info: 'KB: Links Partner with params builder'
        }),
        headers: {
          'Content-type': 'application/json'
        }
      })
      const shortlink: Object = await response.json()
      // @ts-ignore
      return shortlink?.shortUrl || ''
    },
    closeModal (): void {
      this.$emit('closeModal')
    }

  }
}
